export enum TextAlign {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFY = 'justify',
  JUSTIFYLEFT = 'justify-left',
  JUSTIFYCENTER = 'justify-center',
  JUSTIFYRIGHT = 'justify-right'
}
